import React, { Component } from "react";
import "./App.css";
import CardItemMain from "./component/CardItemMain/CardItemMain";

class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: [],
      ptype: ""
    };
  }

  componentDidMount() {
    fetch('/data/data.json')
      .then(response => response.json())
      .then(data => this.setState({ data }));
    this.setState({
      ptype: localStorage.getItem('spr_ptype')
    })
  }

  componentDidUpdate(nextProps, nextState) {
    localStorage.setItem('spr_ptype', this.state.ptype);
  }

  render() {
    return (
      <div className="App">
        <nav>
          <div className="button_wraper">
            <button className="btn btn-primary main_btn" onClick={() => this.setState({ ptype: 'torg' })}>
              Магазины, торговые центры
          </button>
            <button className="btn btn-primary main_btn" onClick={() => this.setState({ ptype: 'apt' })}>
              Аптеки, здравоохранение
          </button>
            <button className="btn btn-primary main_btn" onClick={() => this.setState({ ptype: 'rem' })}>
              Ремонтные мастерские, прочие услуги
          </button>
            <button className="btn btn-primary main_btn" onClick={() => this.setState({ ptype: 'obr' })}>
              Образование, культура
          </button>
            <button className="btn btn-primary main_btn" onClick={() => this.setState({ ptype: 'kr' })}>
              Салоны красоты, прочие услуги
          </button>
            <button className="btn btn-primary main_btn" onClick={() => this.setState({ ptype: 'gkh' })}>
              ЖКХ
          </button>
          </div>
        </nav>
        <div className=" wraper">
          <CardItemMain data={this.state.data} ptype={this.state.ptype} />
        </div>
      </div>
    );
  }
}

export default App;
